import React, {PureComponent} from 'react';
import {CardBody, CardFooter, CardText, CardTitle} from 'reactstrap';

import Availability from '../../Freelance/Component/Availability/Availability.jsx';
import BackCard from '../BackCard.jsx';

export default class FreelanceBackCard extends PureComponent {
  renderSummary = (charMax) => {
    if(!this.props.summary) {
      return null;
    }

    return (this.props.summary.length > charMax ? `${this.props.summary.substring(0, charMax)}...` : this.props.summary)
      .replace(/(<([^>]+)>)/ig,"");
  };

  render() {
    return (
      <BackCard className="h-100 text-center">
        <CardBody className="bg-secondary">
          <div className="text-right">
            <Availability freelance={this.props}/>
          </div>
          <div className="my-2">
            <CardTitle>{this.props.user?.fullname ?? ''}</CardTitle>
            <p>{this.props.user?.title ?? ''}</p>
            <p>{this.props.user?.city?.label ?? ''}</p>
          </div>
          <div className="separator-x bg-gray-50"/>
          <CardText>
            {this.props.currentUser !== null ? this.renderSummary(350) : this.renderSummary(50)}
          </CardText>
        </CardBody>
        <CardFooter>
          <span>Consulter le profil</span>
        </CardFooter>
      </BackCard>
    );
  }
}
